<div [formGroup]="form">
  <h1 class="title">Adresse(s)</h1>
  <h5 class="title-text-muted text-muted fs-16">
    Ajoutez la ou les adresses de votre établissement. La première adresse ajoutée doit être votre siège social.
  </h5>

  <div formArrayName="adresses">
    <ng-container *ngFor="let item of adressesControl.controls; let i = index; let first = first">
      <div [formGroupName]="i" class="border border-1 rounded my-2">
        <div class="border-bottom border-1 p-3 d-flex justify-content-between align-items-center">
          <label class="card-title">
            {{ first ? 'ADRESSE DU SIÈGE SOCIAL' : 'SITE N°' + (i + 1) }}
            <span *ngIf="!first" class="text-secondary">
              {{ addressValidation(i) ? '(Complet)' : '(Incomplet)' }}
            </span>
          </label>
          <svg-icon *ngIf="!first" class="cursor-pointer" src="/assets/icons/trash-red.svg"
            (click)="deleteNewSite(i)"></svg-icon>
        </div>

        <div class="p-4">
          <div class="mb-3">
            <label class="form-label fw-bold text-black fs-14">Nom du site <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="name" />
            <div class="text-danger mt-1"
              *ngIf="adressesControl.at(i).get('name')?.touched && adressesControl.at(i).get('name')?.invalid">
              Ce champ est requis
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label fw-bold text-black fs-14">Adresse du site <span class="text-danger">*</span></label>
            <input type="text" class="form-control" autocomplete="off" formControlName="adress"
              (input)="autoCompleteOnChange($event, i)" [matAutocomplete]="auto" />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngIf="addressLoading" disabled>Recherche en cours…</mat-option>
              <mat-option *ngIf="addressSearched && !addressLoading && !addressList.length" disabled>
                Aucune adresse trouvée
              </mat-option>
              <mat-option *ngFor="let option of addressList" [value]="getAdresseFormated(option)"
                (onSelectionChange)="addressSelected(option, i)">
                {{ getAdresseFormated(option) }}
              </mat-option>
            </mat-autocomplete>
            <small class="text-muted d-block mt-1">Sélectionnez une adresse dans la liste proposée.</small>
            <div class="text-danger mt-1" *ngIf="adressesControl.at(i).get('adress')?.touched && !addressValidation(i)">
              Veuillez sélectionner une adresse valide dans la liste (France)
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold text-black fs-14">Pays <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="pays" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold text-black fs-14">Code postal <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="codePostale" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold text-black fs-14">Ville <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="ville" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold text-black fs-14">Département <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="departmentName" />
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label fw-bold text-black fs-14">CEDEX</label>
            <input type="text" class="form-control" formControlName="cededx" />
          </div>

          <div class="mb-3">
            <app-text-separator text="Photos du site" textClass="fs-14"></app-text-separator>
            <p class="text-black">
              Les photos peuvent offrir aux candidats une vision concrète de votre établissement,
              facilitant ainsi leur compréhension de l'environnement professionnel que vous proposez.
            </p>
            <p class="text-secondary fs-13">Vous pouvez les ajouter ultérieurement.</p>
            <app-custom-dragdrop-image [url]="item.get('addressImages')?.value" [isDeletble]="true" [limit]="2"
              (sendImage)="getImage($event, i)">
            </app-custom-dragdrop-image>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="d-flex justify-content-between align-items-center border rounded p-2 my-2">
    <span class="card-title">Ajouter un site</span>
    <app-button color="primary" [srcIcon]="'assets/icons/plus-circle-primary.svg'" [stroked]="true" text="Ajouter"
      (handleClick)="addAddress()"></app-button>
  </div>

  <!-- <div class="row my-2">
    <app-button color="primary" [disabled]="!form.valid" text="Suivant" (handleClick)="onSubmit.emit()"
      class="mx-auto text-center" [innerClass]="'p-3 w-100'"></app-button>
  </div> -->
</div>